// extracted by mini-css-extract-plugin
module.exports = {"animated":"style-module__animated___b0SKE","fadein":"style-module__fadein___YUDrS"};